import React, {FC} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {Button, Col, Row, SpanBody1, SpanBody2} from "@linkeo.com/ui-lib-react";

interface AppointmentCardProps {
    titlePrestation: string,
    datePrestation: string,
    timezone: string | null,
    clickCancelAppointment?: () => void
}

export const AppointmentCard: FC<AppointmentCardProps> = ({
                                                       titlePrestation,
                                                       datePrestation,
                                                       timezone,
                                                       clickCancelAppointment
                                                   }) => {
    const intl = useIntl();

    return <>
        <Row justifyContent={['space-between']}>
            <Col>
                <div><SpanBody1>{titlePrestation}</SpanBody1></div>
                <SpanBody2><FormattedMessage id="dateTimeFormat" defaultMessage='Le {date} à {time} ' values={{
                    date: intl.formatDate(datePrestation, {
                        dateStyle: "full",
                        timeZone: timezone ? timezone : Intl.DateTimeFormat().resolvedOptions().timeZone
                    }),
                    time: intl.formatTime(datePrestation, {
                        timeStyle: 'short',
                        timeZone: timezone ? timezone : Intl.DateTimeFormat().resolvedOptions().timeZone
                    })
                }}/>
                </SpanBody2>
            </Col>
            <Col>
                {clickCancelAppointment ? (
                    <Button small colorType={"outlineSecondary"} icon={'close-outline'}
                            onClick={clickCancelAppointment}>
                        <FormattedMessage id={"AccountPageAppointmentsCancelButton"} defaultMessage={'Annuler'}/>
                    </Button>
                ) : null}
            </Col>
        </Row>
    </>
}